export const MESSAGE_STANDARD_INFO = 'Hello, welcome to our Patient Billing Customer Service online chat. ' +
    'I would like to mention that the chat is monitored and recorded for quality assurance.';
export const MESSAGE_STANDARD_INFO_WIDGET = 'Chat with a live billing agent now. ' +
    'I would like to mention that the chat is monitored and recorded for quality assurance.';
export const MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT = "We’re very sorry, but all of our agents are assisting other patients right now. " +
    "Please try again in a few minutes. For matters other than patient billing, " +
    "visit <a href='https://www.rsfh.com/contact-us/'>Contact Us - Phone Directory</a> for additional options.";

export const QUEUE_NAME_RSFH_CUSTOMER_SERVICE = 'Roper - CS';
export const QUEUE_TYPE_DEFAULT = 0;
